<template>
    <div class="container-fluid h-100">
        <div class="content-details-com" id="contentdetailc">
            <div class="row justify-content-center align-items-center">
                <div class="col-12 col-md-12 col-lg-5 col-xl-5 ">
                    <div class="row justify-content-center align-items-center h-100">
                        <div class="row justify-content-end">
                            <template v-if="loading.profile">
                                <div class="spinner-border text-light" style="width: 5rem; height: 5rem;" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </template>
                            <template v-else>
                                <div class="col-1 col-md-1 col-lg-1 col-xl-1">
                                    <i style="cursor: pointer;" class="fa fa-arrow-left fa-lg mt-4" @click="irProfile()"
                                        aria-hidden="true"></i>
                                </div>
                                <div class="col-12 col-md-11 col-lg-11 col-xl-11">
                                    <h1 class="title-profile-2">{{dataUser.name}} {{dataUser.last_name}}</h1>
                                </div>
                                <div class="col-12 col-md-11 col-lg-11 col-xl-11" style="text-align: left">
                                    <label style="font-size: 20px;">
                                        {{ documentUser }} {{ dataUser.document_number }}</label>
                                </div>
                                <div class="col-12 col-md-11 col-lg-11 col-xl-11" style="text-align: left">
                                    <label style="font-size: 20px;">TEL: {{ dataUser.phone }}</label>

                                </div>
                                <div class="col-12 col-md-11 col-lg-11 col-xl-11" style="text-align: left">

                                    <label style="font-size: 20px;"> {{ dataUser.email }}</label>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-12 col-lg-7 col-xl-7">
                    <template v-if="loading.table">
                        <div class="spinner-border text-danger" style="width: 5rem; height: 5rem;" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </template>
                    <template v-else>
                        <template v-if="alert">

                            <ul class="nav nav-tabs tab-commercial nav-pills nav-fill" id="myTab" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab"
                                        aria-controls="home" aria-selected="true">Inscribir tapas</a>
                                </li>
                            </ul>
                            <div class="tab-content" id="myTabContent">
                                <div style="background-color: #9e9e9e40" class=" tab-pane fade show active" id="home"
                                    role="tabpanel" aria-labelledby="home-tab">
                                    <paginate class="pt-3 ul-pagination" name="items" :list="items" :per="4">
                                        <!-- <div class="card">
                                            <div class="card-body"> -->
                                        <template v-for="(data, k) in paginated('items')">
                                            <div class="row mr-4 mt-3" :key="`item-${k}`">
                                                <div class="col-12 col-md-9 col-lg-8 col-xl-8" style="text-align: left">
                                                    <label class="detail-label">Fecha de la solicitud:
                                                        {{data.created_at}}</label><br>
                                                    <label class="detail-label">Cantidad de tapas:
                                                        {{data.amount}}</label>

                                                </div>
                                                <div class="col-12 col-md-3 col-lg-4 col-xl-4">
                                                    <button type="button" @click="aprobar(data)"
                                                        class="btn btn-danger btn-sm btn-block">Aprobar</button>
                                                    <button data-toggle="modal" data-target="#exampleModal"
                                                        type="button" class="btn btn-sm btn-block" @click="info = data"
                                                        style="background-color: #D40000; color:#fff">Rechazar</button>
                                                </div>

                                            </div>
                                            <hr class="detail-separator mr-4">
                                        </template>
                                        <!-- </div>
                                        </div> -->
                                    </paginate>
                                    <div class="row justify-content-center">
                                        <div class="col-12 col-md-9 col-lg-2 col-xl-2 col-sm-12  center-paginate">
                                            <div style="text-align: center">
                                                <paginate-links @change="pageChange" for="items" :limit="2"
                                                    :show-step-links="true" :step-links="{next: '>', prev: '<'}"
                                                    :classes="{'ul': 'pagination', 'li': 'page-item', 'a': 'page-link'}">
                                                </paginate-links>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <h3 class="title-list-l">Lista de solicitudes</h3>
                             -->
                            <!-- <div class="row justify-content-center">
                                <div class="col-12 col-md-9 col-lg-2 col-xl-2 col-sm-12 mt-4 center-paginate">
                                    <paginate-links @change="pageChange" for="items" :limit="2" :show-step-links="true"
                                        :step-links="{next: '>', prev: '<'}"
                                        :classes="{'ul': 'pagination', 'li': 'page-item', 'a': 'page-link'}">
                                    </paginate-links>
                                </div>
                            </div> -->
                        </template>
                        <template v-else>
                            <div style="margin-top: 20%; margin-bottom: 20%" class="alert alert-primary " role="alert">
                                No se encontraron resultados
                            </div>
                        </template>
                    </template>
                </div>
            </div>
        </div>


        <!-- Modal -->
        <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content modal-rechazo">
                    <!-- <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel"><b>¿Estás seguro de
                                rechazar la solicitud?</b></h5>
                        <button type="button" style="color: #fff" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div> -->
                    <div class="modal-body">
                        <h5 class="modal-title" id="exampleModalLabel" style="text-align: left"><strong>Rechazo de puntos
                            </strong> <button type="button" style="color: #fff" class="close" data-dismiss="modal"
                                aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button></h5>


                        <div class="form-group" style="text-align: left">
                            <label for="exampleFormControlTextarea1">Explique el motivo del rechazo de puntos</label>

                            <div class="form-group">
                                <div class="input-group mb-3">
                                    <textarea maxlength="255" :class="{ 'is-danger': errors.comments }"
                                        v-model="comments" class="form-control" id="exampleFormControlTextarea1"
                                        rows="3"></textarea>
                                </div>
                                <div style="text-align: right">
                                    <span v-if="errors.comments"
                                        class="text-danger float-left small error-danger mb-2">{{  errors.comments }}</span>
                                    <small :class="{ 'is-dangerT': errors.comments }">
                                        {{countCharacter}} / 255</small>
                                </div>
                            </div>
                        </div>
                        <button type="button" class="btn btn-sm float-left"
                            style="background-color: #00000000; color: #fff; border: 1px solid;" data-dismiss="modal"
                            @click="closeModal()">Cancelar</button>
                        <button type="button" @click="rechazar()" class="btn btn-danger btn-sm float-right">
                            <template v-if="loading.btn">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                <span class="sr-only">Cargando...</span>
                            </template>
                            <template v-else>
                                Rechazar
                            </template>
                        </button>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {STATUS} from "../../../config/utils";
    import $ from 'jquery';
    export default {
        data() {
            return {
                alert: true,
                countCharacter: 0,
                info: null,
                loading: {
                    profile: false,
                    table: false,
                    btn: false
                },
                items: [],
                paginate: ['items'],
                page: 1,
                totalPage: 1,
                dataUser: {
                    last_name: "",
                    name: "",
                    phone: "",
                    email: "",
                    document_number: "",
                },
                documentUser: null,
                listRequest: [],
                comments: "",
                errors: {
                    comments: false
                }
            }
        },
        watch: {
            comments: function (n) {
                this.countCharacter = n.length;
                if (!n) {
                    this.errors.comments = "El comentario es requerido.";
                } else if (this.countCharacter >= 255) {
                    this.errors.comments = "El comentario ha superado el limite de carácteres permitidos.";
                } else {
                    this.errors.comments = false;
                }
            }
        },
        methods: {
            aprobar(data) {
                this.$swal({
                    title: '¿Estás seguro que deseas aprobar la solicitud?',
                    icon: 'warning',
                    confirmButtonColor: "#17a2b8",
                    // showDenyButton: true,
                    showCancelButton: true,
                    confirmButtonText: `Aprobar`,
                    cancelButtonText: `Cancelar`,
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.request(STATUS.APROBADO, data);
                    } else if (result.isDenied) {
                        this.$swal('Changes are not saved', '', 'info')
                    }
                })
            },
            request(type, data1) {
                var data = {
                    lubricator_id: data1.lubricator_id,
                    status_id: type,
                    id: data1.id
                }
                this.loading.table = true;
                console.log(data)
                axios.put("api/commercial/checkCaps", data).then(res => {
                    console.log(res)
                    if (res.data.cod == 0) {
                        this.showLubricator();
                        this.loading.table = false;
                        this.$swal(res.data.message, '', 'success')
                        $('#exampleModal').modal('hide')
                    }
                }).catch(error => {
                    this.loading.table = false;
                    console.log(error)
                })
            },
            rechazar() {
                if (this.validateComments()) {
                    this.loading.btn = true;
                    var data = {
                        comments: this.comments,
                        lubricator_id: this.info.lubricator_id,
                        status_id: STATUS.RECHAZADO,
                        id: this.info.id
                    }
                    console.log(data)
                    axios.put("api/commercial/checkCaps", data).then(res => {
                        console.log(res)
                        if (res.data.cod == 0) {
                            this.showLubricator();
                            $('#exampleModal').modal('hide')
                            this.$swal(res.data.message, '', 'success')
                            this.comments = ""
                            setTimeout(() => {
                                this.errors.comments = false;
                            }, 10);


                        }
                        this.loading.btn = false;
                    }).catch(error => {
                        this.loading.btn = false;
                        this.$swal(error.response.data.message, '', 'error')
                        console.log(error)
                    })
                }
            },

            validateComments() {
                if (!this.comments) {
                    this.errors.comments = "El número de tapas es requerido";
                    if ((this.isNumeric(this.comments)) && (this.comments < 0)) {
                        this.errors.comments = "El número de tapas no puede ser negativo";
                    }
                }
                if (!this.errors.comments) {
                    return true;
                }
                return false;
            },

            irProfile() {
                this.$router.push({name: "comercialProfile"});
            },
            showLubricator() {
                var app = this;
                var id = this.$route.params.id;
                this.loading.profile = true;
                this.loading.table = true;
                axios
                    .get("api/commercial/showCaps/" + id)
                    .then(function (res) {
                        console.log(res)
                        if (res.data.cod == 0) {
                            app.dataUser = res.data.data.lubricatorInfo[0];
                            app.items = res.data.data.lubricatorInfo[0].caps;
                            console.log(app.items)
                            if (app.items.length == 0) {
                                app.alert = false;
                            } else {
                                app.alert = true;
                            }
                        }
                        app.loading.profile = false;
                        app.loading.table = false;
                    })
                    .catch(function (error) {
                        app.loading.profile = false;
                        console.log(error);
                        app.loading.table = false;
                    });
            },
            getRequets() {
                axios.get("api/distributorList").then(res => {
                    console.log(res.data.data)
                    if (res.data.cod == 0) {
                        this.items = res.data.data;
                    }
                }).catch(error => {
                    console.log(error)
                })
            },
            pageChange(toPage) {
                this.page = toPage;
            },

        },
        mounted() {
            this.showLubricator();
            // this.getRequets();
        }
    };
</script>

<style scope>
ul.pagination {
    justify-content: center;
}
.modal-rechazo {
    border: 1px solid;
    background-color: #000000d6;
}
body {
    padding-right: 0px !important;
}
.position-detail {
    text-align: left;
}
.detail-separator {
    /* margin-right: 1px; */
    background-color: #fff;
    margin-top: 1rem !important;
    margin-bottom: 0.2rem !important;
}
.detail-label {
    font-size: 20px;
}
.page-item.active .page-link {
    border-style: none;
    border-radius: 20px;
    background-color: #dc3545;

}
a.page-link {
    color: black;
    cursor: pointer;
    background-color: #fff;
}
a.page-link:hover {
    color: #dc3545;
}
.page-link {
    background-color: #f5f5dc00;
    border-radius: 20px;
    border-color: none;
}
.is-dangerT {
    color: red;
}
.page-item.disabled .page-link {
    color: #dc3545;
    background-color: #fff0;
    border-color: #dee2e600;
}
.title-list-l {
    padding-top: 10%;
    padding-left: 5%;
    font-family: 'GothamBoldItalic', sans-serif;
    color: #dc3545;
    text-align: left;
}
.content-details-com {
    padding-left: 5%;
    padding-top: 10%;
    padding-bottom: 10%;
    height: 100%;
}
#contentdetailc {
    background-size: cover;
    background-image: url("../../../assets/img/FOTO-4.jpg");
    background-position: center center;
    background-attachment: fixed;
    background-color: "#171717";
}
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
    padding-right: 0px !important;
    padding-left: 0px !important;
    overflow: hidden;
}
.title-profile-2 {
    font-family: 'Gotham-UltraItalic', sans-serif;
    text-align: left !important;
    font-size: 50px;
    font-display: swap;
}
.page-item:last-child .page-link {
    background-color: #f0f8ff00;
    color: #dc3545;
    border: none !important;

}
.page-item:first-child .page-link {
    background-color: #f0f8ff00;
    color: #dc3545;
    border: none !important;
}
/* Navegación */
.nav-pills .nav-link {
    background-color: #9e9e9e17;
    font-weight: bold;
    color: #fff;
}
.nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
    color: #fff;
    background-color: #9e9e9e17;
    border-bottom: none !important;
}
.nav-pills {
    border-bottom: none;
}
.tab-commercial {
    background-color: #7d7d7d3d !important;
}

/* LAPTOP NORMAL */
@media (max-width: 1200px) {}

/* TABLET */
@media (max-width: 1023px) {}

/* MOBILE L */
@media (max-width: 767px) {
    ul.ul-pagination {
        padding-inline-start: 0px;
    }
    .content-details-com {
        padding-left: 0%;

    }
    .icon-img-svg-c {
        width: 34px;
        padding-top: 15px;
    }
    .icon-img-svg-c-phone {
        padding: 6px;
    }
}


/* MOBILE M */
@media (max-width: 375px) {
    ul.ul-pagination {
        padding-inline-start: 0px;
    }
    .content-details-com {
        padding-left: 0%;

    }
    .icon-img-svg-c {
        width: 34px;
        padding-top: 15px;
    }
    .icon-img-svg-c-phone {
        padding: 6px;
    }
}

/* MOBILE S */
@media (max-width: 320px) {
    ul.ul-pagination {
        padding-inline-start: 0px;
    }
    .content-details-com {
        padding-left: 0%;

    }
    .icon-img-svg-c {
        width: 34px;
        padding-top: 15px;
    }
    .icon-img-svg-c-phone {
        padding: 6px;
    }
}

@font-face {
    font-family: 'ubuntu-bold';
    src: url('./../../../assets/font/Ubuntu-Bold.ttf');
    font-display: swap;
}
@font-face {
    font-family: "Gotham-UltraItalic";
    src: url("./../../../assets/font/Gotham-UltraItalic.ttf");
    font-display: swap;
}
@font-face {
    font-family: "GothamBoldItalic";
    src: url("./../../../assets/font/GothamBoldItalic.ttf");
    font-display: swap;
}
@font-face {
    font-family: "GothamBookItalic";
    src: url("./../../../assets/font/GothamBookItalic.ttf");
    font-display: swap;
}
</style>